import React, { useState } from 'react';
import './ContactScreen.css';
import PhoneIcon from './media/Phone.png'
import Icon1 from './media/Icon1.png'
import Icon2 from './media/Icon2.png'
import Fasi from './media/FASI.png'
import Inc from './media/INC.png'


const ContactScreen = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    agreement: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Обработка отправки формы
    console.log('Данные формы:', formData);
    // Здесь можно добавить логику отправки данных
  };

  return (
    <div className="contact-screen">
      <div className="contact-title">
        <h2>Мы всегда рады ответить на ваши вопросы</h2>
        <p>Свяжитесь с нами удобным вам способом!</p>
      </div>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-inputs">
          <div className="input-group">
            <label>Ваше имя</label>
            <div className="input-frame">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Например, Евгений"
              />
            </div>
          </div>

          <div className="input-group">
            <label>Ваш email</label>
            <div className="input-frame">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Например, example@mail.com"
              />
            </div>
          </div>

          <div className="input-group">
            <label>Ваш телефон</label>
            <div className="input-frame">
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Например, +7 (900) 123-45-67"
              />
            </div>
          </div>

          <div className="input-group">
            <label>Ваше сообщение</label>
            <div className="input-frame textarea-frame">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Например, я хотел бы узнать больше о вашем продукте"
              />
            </div>
          </div>
        </div>

        <div className="agreement">
          <input
            type="checkbox"
            id="agreement"
            name="agreement"
            checked={formData.agreement}
            onChange={handleInputChange}
            className="agreement-checkbox"
          />
          <label htmlFor="agreement">
            Я даю согласие на обработку моих персональных данных, указанных в этой веб-форме, на условиях, изложенных в Политике в отношении обработки персональных данных в Интернете, с которой я ознакомился
          </label>
        </div>

        <button type="submit" className="submit-button">
          Оставить заявку
        </button>
      </form>

      <div className="phone-image">
        {/* Здесь будет изображение телефона */}
        <div className="phone-placeholder"><img src={PhoneIcon} alt="Text"/></div>
      </div>

      <div className="contact-info">
        <div className="contact-phone">8-911-163-69-01</div>
        <div className="contact-email">OOODynamika@yandex.ru</div>
        
        <div className="social-icons">
          <div className="social-icon"><img src={Icon1} alt="Text"/></div>
          <div className="social-icon"><img src={Icon2} alt="Text"/></div>
        </div>

        <div className="support-info">
          <p>
            Проект создан при поддержке Федерального государственного бюджетного учреждения «Фонд содействия развитию малых форм предприятий в научно-технической сфере в рамках программы «Студенческий стартап» федерального проекта «Платформа университетского технологического предпринимательства» и Бизнес-инкубатора «Бюро интеллектуального сервиса»
          </p>
        </div>

        <div className="emblems">
          <div className="emblem-frame">
            <div className="emblem-placeholder"><img src={Fasi} alt="Text"/></div>
          </div>
          <div className="emblem-frame">
            <div className="emblem-placeholder"><img src={Inc} alt="Text"/></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactScreen;